import styled from 'styled-components';
import { device } from '../breakpoints';
import { regularWhite, fontWeightLight, fontWeightRegular } from '../design-tokens';
import { playFontSize } from '../typography/helpers';

export const StyledSlashHeader = styled.h1`
    color: ${regularWhite};
    font-weight: ${fontWeightLight};
    text-transform: uppercase;
    margin-bottom: 1em;

    ${playFontSize(2.4)}

    @media ${device.GteSmall} {
        ${playFontSize(3)}
    }

    @media ${device.GteLarge} {
        ${playFontSize(3.4)}
    }
`;

export const HeaderText = styled.span`
    vertical-align: middle;
`;

export const PlaySlash = styled.span`
    font-family: Publik !important;
    font-weight: ${fontWeightRegular};
    font-size: 1em;
    vertical-align: middle;

    /* Play slash is now a glyph in font-family. */
    &:before {
        content: '\\221A';
    }
`;
